import type { ReactNode } from "react";
import Select from "./Select";
import { titleOptions as titleOptionsArray } from "@patient-watch/types";

/* oxlint-disable jsx-a11y/no-autofocus -- title is the first field on many invite forms */
const defaultTitleOptions = titleOptionsArray.map((title) => ({
    label: title,
    value: title,
}));

interface TitleOption {
    label: string;
    value: string;
}

interface Props {
    autoFocus?: boolean;
    /** Defaults to `Title`. */
    label?: ReactNode;
    placeholder?: string;
    /** Localised labels; values must stay canonical (Mr, Mrs, etc.). */
    options?: TitleOption[];
}

const SelectTitle = ({ autoFocus, label = "Title", placeholder, options = defaultTitleOptions }: Props) => {
    return (
        <Select
            autoFocus={autoFocus}
            name="title"
            label={label}
            placeholder={placeholder}
            options={options}
            data-testid="title-trigger"
        />
    );
};

export default SelectTitle;
